import { useGlobalStore, usePersistantStore } from "@/stores/global";
import { Box, Paper, ToggleButton } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import SelectPlantDialog from "./dialogs/SelectPlantDialog";
import MixingPlantView from "./listView/MixingPlantView";
import { History } from "@mui/icons-material";
import useRights from "@/shared/api/useRights";
import { DirectNewExternalMaterialBooking } from "./listView/DirectNewExternalMaterialBooking";
import Auslastung from "./listView/Auslastung";
import Schliesstage from "./listView/Schliesstage";
import AmountList from "./listView/AmountList";

export default function MixingPlants() {
  const setPageTitle = useGlobalStore((state) => state.setPageTitle);
  const rights = useRights();
  const reference = usePersistantStore((state) => state.plantReference ?? ("PLANT" in rights ? rights["PLANT"] : "0"));
  const setReference = usePersistantStore((state) => state.setPlantReference);

  const [history, setHistory] = useState(false);

  useEffect(() => setPageTitle("Lieferungen"), [setPageTitle]);

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          p: 1,
          background: "#eee",
        }}
      >
        <Paper sx={{ overflow: "hidden", display: "flex", flexDirection: "column" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                background: "#edf0f9",
                border: "1px solid rgba(0,0,0,0.2)",
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
                display: "flex",
                columnGap: "5px",
                boxShadow: "inset 0px -4px 5px rgba(0,0,0,0.1)" /*borderBottom: "none"*/,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flex: 1,
                  alignItems: "center",
                  ml: "5px",
                  justifyContent: "space-between",
                }}
              >
                <SelectPlantDialog
                  reference={reference}
                  onChange={(reference) => {
                    console.log(reference);
                    setReference(reference);
                  }}
                />
                <div style={{ display: "flex", gap: "10px" }}>
                  <ToggleButton size="small" value="check" selected={history} onChange={() => setHistory((prevSelected) => !prevSelected)}>
                    <History sx={{ mr: 1 }} fontSize="small" /> Vergangenheit
                  </ToggleButton>
                  {"PLANT_ADMIN" in rights || "PLANT" in rights || "DISPOSITION" in rights || "TRANSPORTDISPO" in rights ? (
                    <Auslastung initialPlant={Math.max(0, parseInt(rights["PLANT"] ?? "0") || 0)} />
                  ) : null}
                  {"PLANT_ADMIN" in rights || "PLANT" in rights || "DISPO" in rights || "TRANSPORTDISPO" in rights ? (
                    <AmountList
                      allowedPlant={"PLANT_ADMIN" in rights || "DISPO" in rights || "TRANSPORTDISPO" in rights ? -1 : parseInt(rights["PLANT"])}
                    />
                  ) : null}
                  {"PLANT_ADMIN" in rights || "PLANT" in rights || "DISPO" in rights || "TRANSPORTDISPO" in rights ? (
                    <Schliesstage
                      allowedPlant={"PLANT_ADMIN" in rights || "DISPO" in rights || "TRANSPORTDISPO" in rights ? -1 : parseInt(rights["PLANT"])}
                    />
                  ) : null}
                </div>
                {(!("PLANT" in rights) ? -1 : parseInt(rights["PLANT"])) === parseInt(reference) || "PLANT_ADMIN" in rights ? (
                  <Fragment>
                    <DirectNewExternalMaterialBooking allowedPlant={"PLANT_ADMIN" in rights ? -1 : parseInt(rights["PLANT"])} />
                  </Fragment>
                ) : null}
              </Box>
            </Box>
            <MixingPlantView history={history} reference={reference} />
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
